<div class="p-grid">
  <div class="p-col-12">
    <p-card header="Product Information">
      <div class="card-header">
        <h5>AutoBCM - Lite Package</h5>
      </div>
      <div class="p-d-flex p-grid p-jc-between">
        <div class="p-md-2">
          <button
            pButton
            type="button"
            label="Upgrade"
            icon="pi pi-angle-double-up"
          ></button>
        </div>
        <div class="p-md-10 col-payment">
          Current package is due by 12th-Jan-2022
          <button
            pButton
            type="button"
            class="p-ml-4"
            label="Make Payment"
            icon="pi pi-money-bill"
            (click)="handleMakePayment($event)"
          ></button>
        </div>
      </div>
    </p-card>
  </div>
  <div class="p-col-12">
    <app-base-table [tableId]="tableId"></app-base-table>
  </div>
</div>
<p-dialog
  header="Payment Methods"
  [(visible)]="display"
  [style]="{ width: '400px' }"
  (onShow)="generatePaypalButton()"
>
  <div id="paypal-button"></div>
</p-dialog>
